export default __webpack_public_path__ + "static/media/31.c7f95a49.jpg";